<template>
  <div class="history-list-warp">
  	<y-teacher-info></y-teacher-info>
  	<y-nav></y-nav>
    <div class="history-wrap main">
      <div class="allhistory clearfix">
        <div class="all_left left">
          <img src="~assets/all_history.png" alt="历史直播列表" /> 查看历史
        </div>
        <div class="search left">
          <div class="search_left left">查询：</div>
          <div class="select_right left">
            <el-select v-model="year" placeholder="请选择年份" @change="initMonth" style="padding-right: 5px;">
              <el-option
                v-for="item of optionYears"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="month" :disabled="year === null" @change="push" placeholder="请选择月份">
              <el-option
                v-for="item of optionMonths"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="history_content">
        <div class="content_title clearfix">
          <div class="timer left">日期</div>
          <div class="title left">主题</div>
          <div class="number left">参与人数</div>
          <div class="live left">查看</div>
        </div>
        <ul class="content_text">
          <li v-for="item of list" class="clearfix" :key="item.id">
            <div class="time left">{{ item.createdAt.slice(0, 10) }}</div>
            <div class="text left ellipsis">{{ item.topicName }}</div>
            <div class="number left">{{ item.totalOnline }}</div>
            <!-- 历史直播 -->
            <div v-if="item.status === 21" class="action left">
              <nuxt-link :to="`/room/history/${item.id}`">查看记录</nuxt-link>
            </div>
            <!-- 正在直播 -->
            <div v-else class="action left">
              <nuxt-link class="todaylive" :to="`/room/${item.roomId}`">进入互动</nuxt-link>
            </div>
          </li>
        </ul>
        <!-- 分页 -->
        <y-pager :total="total"></y-pager>
      </div>
      <!-- 底部广告 -->
      <y-elite-introduce></y-elite-introduce>
    </div>
  </div>
</template>

<script>
import YTeacherInfo from '@/components/TeacherInfo'
import YNav from '@/components/Nav'
import YEliteIntroduce from '@/components/room/EliteIntroduce'

function initYear () {
  let beginYear = 2014
  const optionYears = []
  let i = new Date().getFullYear()
  
  while (i >= beginYear) {
    optionYears.push({
      label: i + '年',
      value: i
    })
    i--
  }
  return optionYears
}

function initMonth (y) {
  const optionMonths = []
  const date = new Date()
  // 如果和当前年份相同，就需要判断月份，否则就是12个月
  let i = date.getFullYear() === +y ? date.getMonth() + 1 : 12

  while (i > 0) {
    optionMonths.push({
      label: i + '月',
      value: i
    })
    i--
  }
  return optionMonths
}

export default {
  name: 'room-history-list',
  scrollToTop: true,
  watchQuery: ['page', 'num', 'year', 'month'],
  async asyncData ({ query, params, $axios }) {
    const optionYears = initYear()
    const optionMonths = initMonth(query.year)

    const apiUrl = '/History/List'
    const apiParams = {
      teacher_id: params.id,
      year: query.year || null,
      month: query.month || null,
      page: query.page || 1,
      num: query.num || process.env.DEFAULT_PAGE_SIZE
    }
    let { list, totalCount } = await $axios._get(apiUrl, apiParams)
    
    return {
      apiParams,
      apiUrl,
      year: apiParams.year,
      month: apiParams.month,
      list,
      total: totalCount,
      optionYears,
      optionMonths
    }
  },
  head () {
    let teacher = this.$store.state.teacher.data
    const name = teacher ? teacher.userName : null
    return {
      title: `${name ? (name + '：' + name) : ''}直播室_历史直播_一富财经直播室_一富财经`
    }
  },
  mounted () {
    this.$store.dispatch('teacher/getInfo', this.$route.params.id)
    // 初始可售卖产品
    this.$store.dispatch('teacher/getGoods', this.$route.params.id)
  },
  methods: {
    // 初始化月份
    initMonth (y) {
      this.month = null
      this.optionMonths = initMonth(y)

    },
    push (month) {
      this.$router.push({
        query: {
          year: this.year,
          month
        }
      })
    }
  },
  components: {
  	YTeacherInfo,
		YNav,
    YEliteIntroduce
  }
}
</script>
